import React, { useState } from "react";
import Swal from "sweetalert2";

const ApplyNowForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    organization: "",
    position: "",
    email: "",
    phoneNumber: "",
    preferredProgramme: "",
    deliveryMode: "",
    yearsOfExperience: "",
    professionalGoals: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const fieldLabels = {
    firstName: "First Name",
    lastName: "Last Name",
    organization: "Organization",
    position: "Position/Title",
    email: "Email",
    phoneNumber: "Phone Number",
    preferredProgramme: "Preferred Programme",
    deliveryMode: "Delivery Mode",
    yearsOfExperience: "Years of Relevant Experience",
    professionalGoals: "How This Programme Aligns With Professional Goals",
  };
  const createFormattedData = () => {
    const formattedData = new FormData();
    formattedData.append("_subject", "New Application Form Submission");
    formattedData.append("_captcha", "false");
    formattedData.append("_template", "table");
    Object.keys(formData).forEach((key) => {
      formattedData.append(fieldLabels[key], formData[key]);
    });

    return formattedData;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.lastName || !formData.email) {
      Swal.fire({
        icon: "error",
        title: "Missing Required Fields",
        text: "Please fill in all required fields.",
      });
      return;
    }
    setIsSubmitting(true);
    const formSubmitEndpoint =
      "https://formsubmit.co/ee@sapphirediplomacy.com";
    const data = createFormattedData();

    Swal.fire({
      title: "Submitting your application...",
      text: "Please wait a moment.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: 10000, // 10 seconds
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(formSubmitEndpoint, {
        method: "POST",
        body: data,
      });
      setTimeout(() => {
        setIsSubmitting(false);
        if (response.ok) {
          Swal.fire({
            title: "Application Submitted!",
            text: "Your form has been submitted successfully.",
            icon: "success",
          });

          setFormData({
            firstName: "",
            lastName: "",
            organization: "",
            position: "",
            email: "",
            phoneNumber: "",
            preferredProgramme: "",
            deliveryMode: "",
            yearsOfExperience: "",
            professionalGoals: "",
          });
        } else {
          Swal.fire({
            title: "Submission Error",
            text: "There was an issue submitting your form. Please try again later.",
            icon: "error",
          });
        }
      }, 10000);
    } catch (error) {

      setIsSubmitting(false);
      Swal.fire({
        title: "Network Error",
        text: "There was a problem submitting your form. Please check your connection & try again.",
        icon: "error",
      });
    }
  };

  return (
    <div
      className=" flex items-center justify-center py-16 bg-[#39699D]"
      style={{
        backgroundImage: `url('/image-fix/dark-overlay-bg-images/dark-school-bg-img (1).png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >

      <div className="max-w-3xl w-full bg-[#CAE4FF] rounded shadow-lg p-6 md:p-10 relative m-4">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Application Form
        </h1>
        <div className="bg-gray-500 h-0.5 w-10 mx-auto my-2"></div>

        <form onSubmit={handleSubmit} className="space-y-4 mt-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="w-full md:w-1/2">
              <label htmlFor="firstName" className="block font-semibold mb-1">
                First Name<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="Emmanuel"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
              />
            </div>

            <div className="w-full md:w-1/2">
              <label htmlFor="lastName" className="block font-semibold mb-1">
                Last Name<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Obodai"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <div className="w-full md:w-1/2">
              <label
                htmlFor="organization"
                className="block font-semibold mb-1"
              >
                Organization<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                id="organization"
                name="organization"
                placeholder="Company / Institution"
                value={formData.organization}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>

            <div className="w-full md:w-1/2">
              <label htmlFor="position" className="block font-semibold mb-1">
                Position / Title<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                id="position"
                name="position"
                placeholder="Position/Title"
                value={formData.position}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <div className="w-full md:w-1/2">
              <label htmlFor="email" className="block font-semibold mb-1">
                Email<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@mail.com"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
              />
            </div>

            <div className="w-full md:w-1/2">
              <label htmlFor="phoneNumber" className="block font-semibold mb-1">
                Phone Number<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="+1 234 567 890"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="preferredProgramme"
              className="block font-semibold mb-1"
            >
              Select Your Preferred Programme
              <span className="ml-1 text-red-700">*</span>
            </label>
            <select
              id="preferredProgramme"
              name="preferredProgramme"
              value={formData.preferredProgramme}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            >
              <option value="" disabled>
                -- Select Programme --
              </option>
              <option value="Local Governance and Decentralisation: Driving Grassroots Development">
                Local Governance and Decentralisation: Driving Grassroots
                Development
              </option>
              <option value="Strategic Public Policy Formulation and Implementation for Sustainable Development">
                Strategic Public Policy Formulation and Implementation for
                Sustainable Development
              </option>
              <option value="Digital Transformation and e-Governance: Harnessing Technology for Public Service Delivery">
                Digital Transformation and e-Governance: Harnessing Technology
                for Public Service Delivery
              </option>
              <option value="Ethical Leadership, Transparency, and Accountability in Public Institutions">
                Ethical Leadership, Transparency, and Accountability in Public
                Institutions
              </option>
              <option value="Effective Leadership in State-Owned Institutions">
                Effective Leadership in State-Owned Institutions
              </option>
              <option value="Executive Summer School in Diplomacy and International Relations">
                Executive Summer School in Diplomacy and International Relations
              </option>
            </select>
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <div className="w-full md:w-1/2">
              <label
                htmlFor="deliveryMode"
                className="block font-semibold mb-1"
              >
                What delivery mode do you prefer?
                <span className="ml-1 text-red-700">*</span>
              </label>
              <select
                id="deliveryMode"
                name="deliveryMode"
                value={formData.deliveryMode}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              >
                <option value="" disabled>
                  -- Select Delivery Mode --
                </option>
                <option value="In-Person">In-Person</option>
                <option value="Online">Online</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>
            <div className="w-full md:w-1/2">
              <label
                htmlFor="yearsOfExperience"
                className="block font-semibold mb-1"
              >
                Years of Relevant Experience
                <span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="number"
                id="yearsOfExperience"
                name="yearsOfExperience"
                placeholder="0"
                value={formData.yearsOfExperience}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="professionalGoals"
              className="block font-semibold mb-1"
            >
              How does this programme align with your professional goals?
              <span className="ml-1 text-red-700">*</span>
            </label>
            <textarea
              id="professionalGoals"
              name="professionalGoals"
              value={formData.professionalGoals}
              onChange={handleChange}
              placeholder="Describe your goals here..."
              className="w-full p-2 border rounded"
              rows={4}
              required
            />
          </div>
          <div className="text-center mt-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApplyNowForm;
